// extracted by mini-css-extract-plugin
export default {"tag":"tag__0lCtv","selectedTag":"selectedTag__q2Vng","textContainerEllipsis":"textContainerEllipsis__ncDW0","filterBox":"filterBox__V2m7r","chevron":"chevron__sXpLe"};